namespace TabAurous.OMS {
    export interface LabourPriceListForm {
        PriceCode: Serenity.StringEditor;
        PriceName: Serenity.StringEditor;
        PriceType: Serenity.LookupEditor;
        Narration: Serenity.StringEditor;
        PriceListDetails: LabourPriceListDetailsEditor;
    }

    export class LabourPriceListForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.LabourPriceList';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LabourPriceListForm.init)  {
                LabourPriceListForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = LabourPriceListDetailsEditor;

                Q.initFormType(LabourPriceListForm, [
                    'PriceCode', w0,
                    'PriceName', w0,
                    'PriceType', w1,
                    'Narration', w0,
                    'PriceListDetails', w2
                ]);
            }
        }
    }
}
